import { IHttpService, ILocationService } from "angular";
import { LogBookService } from "ng/src/app/core/services/logbook.service";
import { PrimeNGHelpersService } from "ng/src/app/core/services/primeng-helpers.service";
import { LoggedError } from "ng/src/app/shared/model/error.model";

export class ErrorHandlerService {
	private lastErrorLoggedTime?: number
	private lastErrorLogged?: string
	
    static $inject = ['$http', '$location', 'logBookService', 'primeNGHelpersService']
	constructor(
		private $http: IHttpService,
		private $location: ILocationService,
		private logBookService: LogBookService,
		private primeNGHelpersService: PrimeNGHelpersService
	) { }
	
    handle(message: string, detailMessage: string | undefined, popup = true) {
		popup && this.primeNGHelpersService.showErrorToast(message);

		console.error(message);

		const currentTime = new Date().getTime(),
			logError = !this.lastErrorLoggedTime ||
					   (currentTime - this.lastErrorLoggedTime > 5000 && this.lastErrorLogged != message);

		if (logError) {
			this.lastErrorLoggedTime = currentTime;
			this.lastErrorLogged = message;

			try {
				const data = {
					message: `${message}\n\nBuild Number: ${this.logBookService.LOGBOOK_API_VERSION}\n\n${detailMessage}`,
					url: this.$location.absUrl()
				};

				this.$http.post<LoggedError>('api/loggedErrors', data, {
					noIndicator: true,
					suppressExclusiveRequest: true,
					noErrorPopup: true
				});
			}
			catch(e) {
				console.error(e);
			}
		}
    }
}

angular.module('logbook').service('errorHandler', ErrorHandlerService);